import type { FunctionComponent } from "react";
import { Dot, Site, SiteTabContainer } from "./SiteTabs.styles";
import type { ISiteTabProps } from "./SiteTabs.types";

export const SiteTab: FunctionComponent<ISiteTabProps> = (props) => {
    const { color, isSelected, site, onClick, setOpacity } = props;
    return (
        <SiteTabContainer
            isSelected={isSelected}
            onClick={onClick}
        >
            <Dot
                color={color}
                setOpacity={setOpacity}
            />
            <Site
                isSelected={isSelected}
                setOpacity={setOpacity}
            >
                {site}
            </Site>
        </SiteTabContainer>
    );
};
